import { render, staticRenderFns } from "./AnnouncementNav.vue?vue&type=template&id=0b87c902&scoped=true&"
import script from "./AnnouncementNav.vue?vue&type=script&lang=js&"
export * from "./AnnouncementNav.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementNav.vue?vue&type=style&index=0&id=0b87c902&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87c902",
  null
  
)

export default component.exports